import React from 'react';
import TrackVisibility from 'react-on-screen';
import { StepsWrapper, Step1, Step2, Step3, Step4, Step5, BottomNav } from './components';
import { Auth0AnimationWrapper, OuterContainer, Title, Paragraph } from './styled';

class Auth0Animation extends React.Component {
  state = {
    currentStep: 1,
    navigated: false
  };

  getTextByStep = step => {
    let text = 'default';
    switch (step) {
      case 1:
        text =
          'Choose your use case. Auth0’s Universal Identity Platform for web, mobile and IoT can handle any of them — B2C, B2B, B2E, or a combination.';
        break;
      case 2:
        text =
          'Your language. Your stack. Auth0 can connect to any application or API. Our 65 + SDKs and pre - configured Quickstarts offer rapid integration.';
        break;
      case 3:
        text =
          'Choose the deployment that suits your needs — your cloud, Auth0 Cloud, on-premise, or hybrid.';
        break;
      case 4:
        text =
          'Easily customize your app’s authentication process by writing code or picking one of our 100+ pre-built Auth0 Rules and Extensions.';
        break;
      case 5:
        text =
          'Your use case(s) + Your tech stack + Your deployment model + Your customization + Your changing needs = a seamless and secure Auth0 Identity solution that adapts to your future.';
        break;
      default:
        text =
          'Default .Auth0’s Universal Identity Platform for web, mobile and IoT can handle any of them — B2C, B2B, B2E or a combination.';
    }
    return text;
  };

  selectStep = (step, navigated) => {
    if (navigated) {
      this.setState({ navigated });
    }
    this.setState({
      currentStep: step
    });
  };

  render() {
    const { currentStep, navigated } = this.state;
    return (
      <Auth0AnimationWrapper>
        <OuterContainer>
          <Title>What is Auth0</Title>
          <Paragraph>{this.getTextByStep(currentStep)}</Paragraph>
          <TrackVisibility once partialVisibility>
            {({ isVisible }) =>
              isVisible ? (
                <StepsWrapper>
                  <Step1
                    navigated={navigated}
                    currentStep={currentStep}
                    selectStep={this.selectStep}
                  />
                  <Step2
                    navigated={navigated}
                    currentStep={currentStep}
                    selectStep={this.selectStep}
                  />
                  <Step3
                    navigated={navigated}
                    currentStep={currentStep}
                    selectStep={this.selectStep}
                  />
                  <Step4
                    navigated={navigated}
                    currentStep={currentStep}
                    selectStep={this.selectStep}
                  />
                  <Step5
                    navigated={navigated}
                    currentStep={currentStep}
                    selectStep={this.selectStep}
                  />
                </StepsWrapper>
              ) : (
                <StepsWrapper />
              )
            }
          </TrackVisibility>
          <BottomNav action={this.selectStep} active={currentStep} />
        </OuterContainer>
      </Auth0AnimationWrapper>
    );
  }
}

export default Auth0Animation;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/Auth0Animation.js